export default "__VITE_ASSET__kEVIkgo5__"